import { render, staticRenderFns } from "./OphthalmologyItem.vue?vue&type=template&id=cdbf5cea"
import script from "./OphthalmologyItem.vue?vue&type=script&lang=js"
export * from "./OphthalmologyItem.vue?vue&type=script&lang=js"
import style0 from "./OphthalmologyItem.vue?vue&type=style&index=0&id=cdbf5cea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports